import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../../models/document.model';
import {DetaillineDTOModel} from '../../../models/detaillineDTO.model';
import {ModalController} from '@ionic/angular';
import {NewDocumentService} from '../../../services/new-document.service';
import {ContractHealthCare} from '../contract-health-care/contract-health-care';
import {HandleWardTransferService} from '../../../services/handle-ward-transfer.service';
import {PatientDTOModel} from '../../../models/patientDTO.model';

@Component({
    selector: 'app-equipment-info-modal',
    templateUrl: './equipment-info-modal.component.html',
    styleUrls: ['./equipment-info-modal.component.scss'],
})
export class EquipmentInfoModalComponent implements OnInit {
    @Input() document: DocumentModel;
    @Input() equipment: DetaillineDTOModel;
    status: string;

    constructor(public modalController: ModalController,
                private newDocumentService: NewDocumentService,
                private handleWardTransferService: HandleWardTransferService) {
    }

    ngOnInit() {
        this.status = this.switchStatus();
    }

    createTransfer() {
        const tempDocument = JSON.parse(JSON.stringify(this.document)) as DocumentModel;
        this.handleWardTransferService.handleTransfer(tempDocument, this.equipment);
        this.modalController.dismiss();
    }

    async createContract() {
        const tempEquipment = JSON.parse(JSON.stringify(this.equipment)) as DetaillineDTOModel;
        tempEquipment.detailLineId = 0;
        this.document.documentType = 1;
        tempEquipment.fromDate = this.document.creationDate;
        this.document.detailLines = [tempEquipment];
        const modal = await this.modalController.create({
            component: ContractHealthCare,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {
                document: this.document
            }
        });
        modal.onDidDismiss().then(() => {
            this.modalController.dismiss();
        });
        return await modal.present();
    }

    switchStatus() {
        switch (this.equipment.stat) {
            case 1: {
                return 'Available';
            }
            case 2: {
                return 'In use';
            }
            case 200: {
                return 'Buffer';
            }
            default: {
                return 'Alert';
            }
        }
    }
}
